import { render, staticRenderFns } from "./IndexMedia.vue?vue&type=template&id=536a6dd6"
import script from "./IndexMedia.vue?vue&type=script&lang=js"
export * from "./IndexMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports